"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGenericErcProblem = convertGenericErcProblem;
const common_1 = require("./common");
/**
 * Generic ERC problem converter that handles all ERC validators.
 * This converter extracts element labels and UIDs from affected items,
 * handling both element UIDs and terminal IDs (format: elementUid__terminalUid).
 */
function convertGenericErcProblem(schematicElements) {
    return (problem) => {
        const designatorUidMap = {};
        const name = problem.affectedItems
            .map((a) => {
            // Use itemLabel for display (includes pin designator like "U2:EN" or "U2:4")
            // For terminals, the UID is in format "elementUid__terminalUid", so extract element UID
            // Check for "__" delimiter to detect terminal IDs (used by ERC validators)
            const isTerminalId = a.uid.includes("__");
            const elementUid = isTerminalId ? a.uid.split("__")[0] : a.uid;
            const element = schematicElements[elementUid ?? ""];
            const displayName = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForSchematicNode)(elementUid ?? a.uid, schematicElements));
            // Use element.label for the designatorUidMap key when available (e.g., "U2")
            // For unannotated components or when element is not found, use the UID directly
            // This ensures the link always works via useFitToDesignator's UID matching
            const elementLabel = (0, common_1.sanitizeDesignator)(element?.label);
            if (elementUid) {
                // Map using label if available, otherwise use UID as key
                const mapKey = elementLabel || elementUid;
                designatorUidMap[mapKey] = elementUid;
                // When displayName is a pin identifier (e.g. "U2:VCC"), add it so the link works
                if (displayName && displayName.includes(":") && displayName !== mapKey) {
                    designatorUidMap[displayName] = elementUid;
                }
            }
            return displayName;
        })
            .join(", ");
        // Extract severity from metadata
        const status = (0, common_1.ercSeverityToReviewStatus)(problem.metadata?.ercSeverity);
        if (problem.metadata?.ercNet != null) {
            const netName = String(problem.metadata.ercNet);
            // Use ercTerminalId when present (e.g. single-pin net: affected item is the net, link is the pin's component)
            const terminalOrFirstUid = problem.metadata.ercTerminalId ?? problem.affectedItems[0]?.uid;
            const elementUid = terminalOrFirstUid?.includes("__")
                ? terminalOrFirstUid.split("__")[0]
                : terminalOrFirstUid;
            if (elementUid) {
                designatorUidMap[netName] = elementUid;
            }
        }
        const item = {
            name: name || problem.label || null,
            designatorUidMap,
            status,
        };
        if (problem.metadata?.ercNet != null) {
            item.net = String(problem.metadata.ercNet);
        }
        if (problem.metadata?.ercPinLabel != null) {
            item.pin = String(problem.metadata.ercPinLabel);
        }
        return item;
    };
}
//# sourceMappingURL=genericErc.js.map